<template>
  <div>
    <Navbar />
    <Breadcrumb />
    <div class="mx-auto container-xl mb-5">
      <div class="">
        <div class="title-area">
          <h1 class="page-title h2 mb-2">Survey: <span :class="`${anon ? 'g-anon-lg' : ''}`">{{ survey_name }}</span></h1>
          <div class="text-md">
            Group: <router-link :to="{ name: 'grouppagegroup', params: { id: $store.state.currentgroup_id } }">{{ group_name }}</router-link>
          </div>
        </div>
        <div class="d-flex border-section justify-content-between">
          <GroupSurveyInfoForm
            :survey="survey"
            :anon="anon"
            :loading="loading"
            :screentexts="screentexts"
            :survey-status-id="survey_status_id"
            :surveytype-name="surveytype_name"
            :survey-start-date="survey_start_date"
            :survey-start-time="survey_start_time"
            :survey-end-date="survey_end_date"
            :survey-reminder="survey_reminder"
            :survey-reminder-date="survey_reminder_date"
            :survey-reminder-email="survey_reminder_email"
            :reminder-date-min="reminder_date_min"
            :canremind="canremind"
            :language-options="language_options"
            :norm-values-options="norm_values_options"
            :survey-normvalues-id="survey_normvalues_id"
            :normvalues-country-name="normvalues_country_name"
            :language-name="language_name"
            @update:survey-name="survey.survey_name = $event"
            @update:survey-language-id="survey.survey_language_id = $event"
            @update:survey-start-date="survey_start_date = $event"
            @update:survey-start-time="survey_start_time = $event"
            @update:survey-normvalues-id="survey_normvalues_id = $event"
            @update:survey-reminder="survey_reminder = $event"
            @update:survey-reminder-date="survey_reminder_date = $event"
            @update:survey-reminder-email="survey_reminder_email = $event"
            @survey-updated="survey_get"
            @survey-date-changed="surveychanged = !surveychanged"
          />
          <GroupSurveyStatusPanel
            :survey-status-id="survey_status_id"
            :survey-start-date="survey_start_date"
            :survey-end-date="survey_end_date"
            :completecount="completecount"
            :membercount="membercount"
            :has-paper="has_paper"
            :spotify="spotify"
            :asadmin="asadmin"
            :screentexts="screentexts"
            @print-paperforms="print_paperforms"
            @launch="groupsurvey_launch"
            @close-ask="groupsurvey_close_ask"
            @reopen="groupsurvey_reopen"
            @report="groupsurvey_report"
          />
        </div>
        <GroupSurveyAdminPanel
          v-if="asadmin"
          :survey-type-id="survey_type_id"
          @survey-updated="survey_get"
        />
      </div>

      <GroupSurveyParticipantsSection
        :survey-status-id="survey_status_id"
        :screentexts="screentexts"
        :surveychanged="surveychanged"
        @survey-updated="survey_get"
      />
    </div>
    <BaseModal v-model="wanttoclose" title="Close survey?">
      <template #default>
        <p>When you close the survey, participants can no longer fill in answers, and you can download the survey report</p>
        <div v-if="Number(anonymize_survey_on_close) === 1">
          <p></p>
          <p class="text-danger"><strong>All personal information in the survey will be anonymized. This cannot be undone.</strong></p>
          <div class="form-check mt-2">
            <input
              id="confirmAnonymizeCheck"
              v-model="confirmAnonymize"
              class="form-check-input"
              type="checkbox"
            >
            <label class="form-check-label" for="confirmAnonymizeCheck">
              I understand that all personal data will be permanently deleted
            </label>
          </div>
        </div>
      </template>
      <template #modal-footer>
        <button
          type="button"
          class="btn mt-3 w-100"
          :class="Number(anonymize_survey_on_close) === 1 ? 'btn-danger' : 'btn-primary'"
          :disabled="Number(anonymize_survey_on_close) === 1 && !confirmAnonymize"
          @click="groupsurvey_close"
        >
          Yes, close
        </button>
        <button type="button" class="btn btn-secondary mt-2 w-100" @click="groupsurvey_close_cancel">
          Cancel
        </button>
      </template>
    </BaseModal>
  </div>
</template>
<script>
import Navbar from './Navbar.vue'
import Breadcrumb from './Breadcrumb.vue'
import { config } from '../../config'
import GroupSurveyInfoForm from './GroupSurveyInfoForm.vue'
import GroupSurveyStatusPanel from './GroupSurveyStatusPanel.vue'
import GroupSurveyAdminPanel from './GroupSurveyAdminPanel.vue'
import GroupSurveyParticipantsSection from './GroupSurveyParticipantsSection.vue'

export default {
name: 'GroupSurveyPage',
  components: {
    Navbar,
    Breadcrumb,
    GroupSurveyInfoForm,
    GroupSurveyStatusPanel,
    GroupSurveyAdminPanel,
    GroupSurveyParticipantsSection
  },
  data () {
    return {
      loading: true,
      group_name: this.$store.state.currentgroup.group_name,
      surveytype_name: 'GDQ',
      survey: this.$store.state.currentsurvey,
      survey_name: null,
      survey_type_id: null,
      survey_status_id: null,
      survey_start_date: null,
      survey_start_time: null,
      survey_end_date: null,
      survey_end_time: null,
      survey_reminder: 0,
      survey_reminder_date: null,
      survey_reminder_time: null,
      survey_reminder_email: null,
      has_paper: 0,
      screen_id: 7,
      screentexts: [],
      language_options: [],
      norm_values_options: [],
      surveychanged: false,
      anonymize_survey_on_close: this.$store.state.profile.anonymize_survey_on_close,
      wanttoclose: false,
      confirmAnonymize: false,
      languages: [],
      profile: this.$store.state.profile,
      spotify: this.$store.state.currentsurvey.spotify,
      survey_normvalues_id: this.$store.state.currentsurvey.survey_normvalues_id,
      survey_language_id: this.$store.state.currentsurvey.survey_language_id,
      normvalues_countries: this.$store.state.normvalues_countries
    }
  },
  computed: {
    asadmin () {
      return this.$store.state.asadmin
    },
    normvalues_country_name: {
      get () {
        let name = ''
        for (let i = 0; i < this.normvalues_countries.length; i++) {
          if (Number(this.normvalues_countries[i].country_id) === Number(this.survey_normvalues_id)) {
            name = this.normvalues_countries[i].country_name
          }
        }
        return name
      },
      set () { return true }
    },
    language_name: {
      get () {
        const langid = this.survey.survey_language_id
        for (let i = 0; i < this.languages.length; i++) {
          if (Number(this.languages[i].id) === Number(langid)) return this.languages[i].language_name
        }
        return ''
      },
      set () { return true }
    },
    anon () { return this.$store.state.anon },
    completecount: {
      get () { return this.$store.state.currentsurvey.completecount },
      set () { return true }
    },
    membercount: {
      get () { return this.$store.state.currentsurvey.membercount },
      set () { return true }
    },
    survey_status: {
      get () {
        let status = 'launched'
        if (Number(this.survey_status_id) === 1) status = 'draft'
        if (Number(this.survey_status_id) === 2 && this.survey_start_date && this.survey_start_time) {
          const scheduledAt = new Date(`${this.survey_start_date}T${this.survey_start_time}:00`)
          if (scheduledAt > new Date()) status = 'scheduled'
        }
        return status
      },
      set () { return true }
    },
    survey_id: {
      get () { return this.$store.state.currentsurvey.id },
      set () { return true }
    },
    reminder_date_min: {
      get () {
        if (!this.survey_start_date) return null
        let newvalue = new Date(Date.parse(this.survey_start_date))
        newvalue.setDate(newvalue.getDate() + 1)
        const thisdate = new Date()
        if (thisdate > newvalue) {
          newvalue = thisdate
          newvalue.setDate(newvalue.getDate() + 1)
        }
        return newvalue
      },
      set () { return true }
    },
    canremind: {
      get () {
        if (!this.survey_end_date) return false
        const nowvalue = new Date().toISOString().split('T')[0]
        const endvalue = new Date(Date.parse(this.survey_end_date)).toISOString().split('T')[0]
        return endvalue > nowvalue
      },
      set () { return true }
    }
  },
  created () {
    this.survey_get()
    this.group_get()
    this.languages_get()
    this.normvalues_countries_get()
    this.surveytypes_get()
    this.formoptions_get()
    this.screentexts_get()
  },
  mounted () {
    this.$nextTick(() => {
      const collapseButton = document.getElementById('scrollto')
      const collapseElement = document.getElementById('accordion-1')
      if (collapseButton && collapseElement) {
        collapseButton.addEventListener('click', (event) => {
          event.preventDefault()
          event.stopPropagation()
          if (collapseElement.classList.contains('show')) {
            collapseElement.classList.remove('show')
            collapseButton.classList.add('collapsed')
            collapseButton.setAttribute('aria-expanded', 'false')
          } else {
            collapseElement.classList.add('show')
            collapseButton.classList.remove('collapsed')
            collapseButton.setAttribute('aria-expanded', 'true')
          }
        })
      }
    })
  },
  methods: {
    formoptions_get () {
      this.$store.dispatch('formoptions_fetch')
    },
    languages_get () {
      this.$store.dispatch('languages_fetch')
        .then(res => { this.languages = res.data.result })
    },
    language_options_get () {
      const survey_type_id = this.survey_type_id
      const filter = {}
      switch (survey_type_id) {
        case '1':
          filter.language_enabled = { operator: '=', value: '1' }
          break
        case '2':
          filter.language_enabled_gdq_short = { operator: '=', value: '1' }
          break
        case '3':
          filter.language_enabled_osc = { operator: '=', value: '1' }
          break
        default:
          filter.language_enabled = { operator: '=', value: '1' }
      }
      this.$store.dispatch('records_readall', { table_name: 'g_languages', filter, orderby: 'language_name' })
        .then(resp => {
          this.language_options = resp.data.result.map(r => ({ value: r.id, text: r.language_name }))
        })
    },
    normvalues_countries_get () {
      const survey_type_id = this.survey_type_id
      this.$store.dispatch('normvalues_countries_fetch')
        .then(resp => {
          const options = [{ value: 0, text: 'Please select norm values' }]
          for (let i = 0; i < resp.data.length; i++) {
            if (Number(resp.data[i].country_id) === 999 || Number(survey_type_id) === 1) {
              options.push({ value: resp.data[i].country_id, text: resp.data[i].country_name })
            }
          }
          this.norm_values_options = options
        })
    },
    surveytypes_get () {
      this.$store.dispatch('surveytypes_fetch')
    },
    screentexts_get () {
      const screentexts = []
      const filter = { screen_id: { operator: '=', value: this.screen_id } }
      this.$store.dispatch('systemscreenelements_fetch', { filter })
        .then(resp => {
          const dbtexts = resp.data.result
          for (let i = 0; i < dbtexts.length; i++) {
            screentexts[dbtexts[i].id] = {
              id: dbtexts[i].id,
              element_text: dbtexts[i].element_text,
              element_bubbletext: dbtexts[i].element_bubbletext
            }
          }
          this.screentexts = screentexts
        })
    },
    print_paperforms () {
      this.$store.dispatch('paperforms_fetch', { survey_id: this.$store.state.currentsurvey.id })
        .then(resp => {
          window.open(config.report_url + '/gdq_paperforms.php?i=' + resp.data.id)
        })
    },
    groupsurvey_report () {
      this.$router.push('/group/survey/report')
    },
    async groupsurvey_reopen () {
      const data = { id: this.$store.state.currentsurvey.id, survey_status_id: 3 }
      this.survey.survey_status_id = 3
      await this.$store.dispatch('groupsurvey_save', { survey: data }).then(() => { this.survey_get() })
    },
    groupsurvey_close_ask () {
      this.confirmAnonymize = false
      this.wanttoclose = true
    },
    groupsurvey_close_cancel () {
      this.wanttoclose = false
    },
    async groupsurvey_close () {
      if (Number(this.anonymize_survey_on_close) === 1) {
        await this.$store.dispatch('groupsurvey_anonymize', { survey_id: this.$store.state.currentsurvey.id })
      }
      this.$store.dispatch('groupsurvey_close', { survey: this.$store.state.currentsurvey })
        .then(() => {
          this.wanttoclose = false
          this.survey_get()
          this.$store.dispatch('surveymembers_setreload', { reload: 1 })
        })
    },
    cetdate_get: async function () {
      const resp = await this.$store.dispatch('serverdate_fetch')
      return resp.data
    },
    async groupsurvey_launch () {
      this.survey_status_id = 3
      const mailrecipients = []
      for (let i = 0; i < this.$store.state.currentsurveymembers.length; i++) {
        if (Number(this.$store.state.currentsurveymembers[i].groupsurveymember_formoption_id) === 1) {
          mailrecipients.push(this.$store.state.currentsurveymembers[i])
        }
      }
      const payload = {
        survey: this.$store.state.currentsurvey,
        surveymembers: mailrecipients,
        mail_subject: this.$store.state.currentsurvey.survey_invitation_subject,
        mail_text: this.$store.state.currentsurvey.survey_invitation_text,
        mail_consultant_text: this.$store.state.currentsurvey.survey_invitation_consultant_text,
        mail_cc: this.$store.state.currentsurvey.survey_invitation_cc,
        mail_type: 'Invitation'
      }
      await this.$store.dispatch('groupsurvey_mail', payload)
      const serverdate = await this.cetdate_get()
      const data = {
        id: this.$store.state.currentsurvey.id,
        survey_status_id: 3,
        survey_start_date: serverdate
      }
      await this.$store.dispatch('groupsurvey_save', { survey: data })
      const dbsurvey = await this.survey_get()
      this.survey = dbsurvey
      await this.$store.dispatch('surveymembers_setreload', { reload: 1 })
    },
    redirect_if_incomplete () {
      const missingName = !this.survey_name || this.survey_name.trim() === ''
      const missingStart = !this.survey_start_date || this.survey_start_date.startsWith('1970')
      if (missingName || missingStart) {
        const gid = this.$store.state.currentgroup_id || (this.survey && this.survey.group_id) || null
        if (gid) this.$store.dispatch('group_setcurrent', gid)
        this.$router.replace('/create/group/survey/details')
      }
    },
    cet_to_date (datePart, timePart) {
      if (!datePart || !timePart || String(timePart).length !== 5) return null
      const attempt = new Date(`${datePart}T${timePart}:00+01:00`)
      const check = attempt.toLocaleString('sv-SE', { timeZone: 'Europe/Berlin' }).split(' ')[1].substring(0, 5)
      return check === timePart ? attempt : new Date(`${datePart}T${timePart}:00+02:00`)
    },
    format_date (date) {
      if (!date) return ''
      if (date instanceof Date) return date.toLocaleDateString('sv-SE', { timeZone: 'Europe/Berlin' })
      return String(date).substring(0, 10)
    },
    survey_get: async function () {
      this.loading = true
      const res = await this.$store
        .dispatch('groupsurvey_fetch', { id: this.survey_id })
        .then(res => {
          this.$store.commit('survey_set', res.data)
          this.group_name = this.$store.state.currentgroup.group_name
          this.survey_name = res.data.survey_name || ''
          this.survey_start_date = null
          this.survey_start_time = null
          if (res.data.survey_start_date > '2000-01-01') {
            const d = this.cet_to_date(res.data.survey_start_date, res.data.survey_start_time)
            if (d) {
              this.survey_start_date = d.toLocaleDateString('sv-SE')
              this.survey_start_time = d.toLocaleTimeString('sv-SE', { hour: '2-digit', minute: '2-digit' })
            }
          }
          this.survey_end_date = null
          if (res.data.survey_end_date > '2000-01-01') {
            this.survey_end_date = this.format_date(res.data.survey_end_date) + 'T00:00:00.00Z'
            this.survey_end_time = res.data.survey_end_time || '23:59'
          } else {
            this.survey_end_time = null
          }
          this.survey_reminder = res.data.survey_reminder
          if (res.data.survey_reminder_date > '2000-01-01') {
            this.survey_reminder_date = this.format_date(res.data.survey_reminder_date) + 'T00:00:00.00Z'
            this.survey_reminder_time = res.data.survey_reminder_time
          }
          this.survey_reminder_email = res.data.survey_reminder_email
          this.survey_language_id = res.data.survey_language_id
          this.survey_normvalues_id = res.data.survey_normvalues_id
          this.survey_type_id = Number(res.data.survey_type_id) || res.data.survey_type_id
          this.survey_status_id = Number(res.data.survey_status_id) || 0
          this.survey.survey_status_id = this.survey_status_id
          this.spotify = res.data.spotify
          this.redirect_if_incomplete()

          const members = this.$store.state.currentsurveymembers
          for (let i = 0; i < members.length; i++) {
            if (Number(members[i].groupsurveymember_formoption_id) === 2) this.has_paper = 1
          }
          this.$store.dispatch('record_read', { table_name: 'g_surveytypes', id: this.survey_type_id })
            .then(resp => { this.surveytype_name = resp.data.surveytype_name })
            .then(() => { this.language_options_get() })
            .then(() => { this.normvalues_countries_get() })
          this.loading = false
          return res.data
        })
      return res
    },
    group_get () {
      this.$store.dispatch('group_fetch', { id: this.$store.state.currentgroup_id })
        .then(() => { this.group_name = this.$store.state.currentgroup.group_name })
    }
  }
}
</script>
<style scoped>
.gdq-strike {
  text-decoration: line-through;
}

/* Override Bootstrap dropdown styles to ensure bg-secondary is applied */
.dropdown-menu.bg-secondary {
  background-color: #6c757d !important;
}

.dropdown-menu.bg-secondary .dropdown-item.bg-secondary {
  background-color: #6c757d !important;
  color: white !important;
}

.dropdown-menu.bg-secondary .dropdown-item.bg-secondary:hover {
  background-color: #5a6268 !important;
  color: white !important;
}

.status-tag {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 44px;
  box-sizing: border-box;
  padding: 8px;
  margin: 0;
  line-height: 1.2;
  font-size: inherit;
  font-weight: 400;
  border-radius: 0;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

:deep(td.color-input) {
  padding: 0 !important;
  border: 0 !important;
}

:deep(td.color-input .status-tag) {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 44px;
  box-sizing: border-box;
  padding: 8px;
  margin: 0;
  line-height: 1.2;
  font-size: inherit;
  font-weight: 400;
  border-radius: 0;
  text-align: left;
  border: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

:deep(.actions-table th.select-th input.form-check-input),
:deep(.actions-table td.select-td input.form-check-input) {
  width: 1rem;
  height: 1rem;
  margin: 0;
  padding: 0;
  appearance: none !important;
  -webkit-appearance: none !important;
  opacity: 1 !important;
  position: static !important;
  display: inline-block !important;
  z-index: 1;
  pointer-events: auto;
  background-color: #fff;
  border: 1px solid #adb5bd !important;
  border-radius: 0.25rem;
  box-shadow: none;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 0.65rem 0.65rem;
}

:deep(.actions-table td.select-td input.form-check-input:checked),
:deep(.actions-table th.select-th input.form-check-input:checked) {
  background-color: #007d8f !important;
  border-color: #007d8f !important;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-width='3' d='M5 10l3 3 7-7'/%3e%3c/svg%3e");
}

:deep(.actions-table td.select-td),
:deep(.actions-table th.select-th) {
  width: 16px;
  min-width: 16px;
  padding-left: 0;
  padding-right: 0;
  border: 0;
  text-align: center;
  vertical-align: middle;
}
</style>
